export const attachDebugMode = () => {
  const params = new URLSearchParams(window.location.search)
  const value = params.get('debug')
  if (value === 'on') {
    localStorage.setItem('jro.debug', 'true')
  } else if (value === 'off') {
    localStorage.removeItem('jro.debug')
  }

  const isDebugMode = localStorage.getItem('jro.debug') === 'true'

  if (!isDebugMode) {
    return
  }

  console.log(`
    :::::::::::::::::::::::::::::::::::::
    :::                               :::
    :::  🪲 JRO DEBUG MODE ENABLED 🪲  :::
    :::                               :::
    :::===============================:::
    ::: To disable, add ?debug=off to :::
    ::: the URL                       ::: 
    :::::::::::::::::::::::::::::::::::::
  `)

  window.document.body.classList.add('enable-debug-mode')

  // TODO - feel free to replace this with react
  const debuggerPanel = document.createElement('div')
  debuggerPanel.classList.add('tailwind-scope')
  window.jroDebug.disableDebugMode = () => {
    localStorage.removeItem('jro.debug')
    const url = new URL(window.location.toString());
    url.searchParams.delete('debug');
    window.history.replaceState({}, document.title, url);
    window.location.reload()
  }
  debuggerPanel.innerHTML = `
    <div style="position: fixed; top: 0; right: 0; background-color: rgba(0, 0, 0, 0.8); z-index: 999999; display: flex; align-items: center; justify-content: center;">
      <div class="text-white text-sm border-white border-2 rounded-lg p-2">
        🐞 JRO Debug Mode enabled
        <span role="button" class="ml-3 underline cursor-pointer" onclick="window.jroDebug.disableDebugMode()">Disable</span>
      </div>
    </div>
  `
  window.document.body.appendChild(debuggerPanel)
}